// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input_input__ZJEhq {
  box-sizing: border-box;
  background: transparent;
  border: none;
  color: var(--font-primary-color);
}
.Input_input__ZJEhq:focus {
  outline: none;
}
.Input_input__ZJEhq.Input_full-width__CUCh5 {
  width: 100%;
}
.Input_input__ZJEhq.Input_input__ZJEhq[type=date]::-webkit-inner-spin-button, .Input_input__ZJEhq.Input_input__ZJEhq[type=date]::-webkit-calendar-picker-indicator {
  position: absolute;
  width: 70%;
  left: 30%;
  height: 100%;
  filter: opacity(0);
  border: 1px solid red;
  background-color: transparent;
}
.Input_input__ZJEhq:disabled {
  color: inherit;
}

.Input_label__CwmRf {
  font-size: small;
  color: var(--font-secondary-color);
}

.Input_error__yycwm {
  margin-top: 2px;
  font-size: small;
  color: #df6767;
}

.Input_container__O7xEZ {
  margin: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.Input_field__9wzgX {
  box-sizing: border-box;
  padding: 12px;
  background-color: #fff;
  border: solid 1px #acacac;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  gap: 10px;
  position: relative;
}
.Input_field__9wzgX.Input_fieldError__VeznZ {
  border-color: #df6767;
}
.Input_field__9wzgX:focus, .Input_field__9wzgX:focus-within {
  outline: none;
  border-color: var(--accent-color);
}
.Input_field__9wzgX.Input_isDisabled__P\\+LP\\+ {
  background-color: #dbdbdb;
  color: #838383;
}

.Input_durationInputContainer__-KHbN {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.Input_durationHoursInput__bGLJJ, .Input_durationMinutesInput__Fk56W {
  border: none;
  background: transparent;
  width: 2ch;
  font-weight: inherit;
  box-sizing: content-box;
  transition: width 0.2s;
}
.Input_durationHoursInput__bGLJJ:focus, .Input_durationMinutesInput__Fk56W:focus {
  outline: none;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Input/Input.module.scss","webpack://./src/_common/scss/_colors.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gCCJa;ADEf;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;AAME;EAEE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;AALJ;AAQE;EACE,cAAA;AANJ;;AAUA;EACE,gBAAA;EACA,kCC/Be;ADwBjB;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cC5BM;ADqBR;;AAUA;EACE,YEnCS;EFoCT,aAAA;EACA,sBAAA;EACA,QAAA;AAPF;;AAUA;EACE,sBAAA;EACA,aAAA;EACA,sBC5BmB;ED6BnB,yBE3Be;EF4Bf,kBEtDc;EFuDd,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AAPF;AASE;EACE,qBCpDI;AD6CR;AAUE;EAEE,aAAA;EACA,iCCrEK;AD4DT;AAYE;EACE,yBCpEO;EDqEP,cCnEO;ADyDX;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAXF;;AAcA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;AAXF;AAaI;EACE,aAAA;EACA,iBAAA;AAXN","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.input {\n  box-sizing: border-box;\n  background: transparent;\n  border: none;\n  color: $font-primary;\n\n  &:focus {\n    outline: none;\n  }\n\n  &.full-width {\n    width: 100%;\n  }\n\n  &.input[type='date']::-webkit-inner-spin-button,\n  &.input[type='date']::-webkit-calendar-picker-indicator {\n    position: absolute;\n    width: 70%;\n    left: 30%;\n    height: 100%;\n    filter: opacity(0);\n    border: 1px solid red;\n    background-color: transparent;\n  }\n\n  &:disabled {\n    color: inherit;\n  }\n}\n\n.label {\n  font-size: small;\n  color: $font-secondary;\n}\n\n.error {\n  margin-top: 2px;\n  font-size: small;\n  color: $error;\n}\n\n.container {\n  margin: $margin-m;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.field {\n  box-sizing: border-box;\n  padding: 12px;\n  background-color: $default-control-bg;\n  border: $default-border;\n  border-radius: $border-radius;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: right;\n  gap: 10px;\n  position: relative;\n\n  &.fieldError {\n    border-color: $error;\n  }\n\n  &:focus,\n  &:focus-within {\n    outline: none;\n    border-color: $accent;\n  }\n\n  &.isDisabled {\n    background-color: $grey-200;\n    color: $grey-400;\n  }\n}\n\n.durationInputContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.durationHoursInput, .durationMinutesInput {\n  border: none;\n  background: transparent;\n  width: 2ch;\n  font-weight: inherit;\n  box-sizing: content-box;\n  transition: width 0.2s;\n\n    &:focus {\n      outline: none;\n      font-weight: bold;\n    }\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `Input_input__ZJEhq`,
	"full-width": `Input_full-width__CUCh5`,
	"label": `Input_label__CwmRf`,
	"error": `Input_error__yycwm`,
	"container": `Input_container__O7xEZ`,
	"field": `Input_field__9wzgX`,
	"fieldError": `Input_fieldError__VeznZ`,
	"isDisabled": `Input_isDisabled__P+LP+`,
	"durationInputContainer": `Input_durationInputContainer__-KHbN`,
	"durationHoursInput": `Input_durationHoursInput__bGLJJ`,
	"durationMinutesInput": `Input_durationMinutesInput__Fk56W`
};
export default ___CSS_LOADER_EXPORT___;
